import React from 'react';

import { IconTypes } from '@eika/icon';
import { Label, LabelTypes } from '@eika/label';

import { SignatarDTO } from '../../../generated-types';
import { SigningOrderStatusEnum } from '../../../interfaces/StatusEnums';
import { useTranslation } from '../../../translations';
import { formatTranslation } from '../../../translations/useTranslation';
import { formatDate } from '../../../utils/dateUtils';

import './SigningOrderLabels.scss';

interface SigningOrderLabelsInterface {
    status?: SigningOrderStatusEnum;
    deadline?: string;
    signee?: SignatarDTO;
    deadlineIsToday: boolean;
}
const SigningOrderLabels = ({ status, deadline, signee, deadlineIsToday }: SigningOrderLabelsInterface) => {
    const { taskStatus } = useTranslation();
    const signingDate = signee && signee.signeringstidspunkt && formatDate(new Date(signee.signeringstidspunkt));

    if (status === SigningOrderStatusEnum.EXPIRED) {
        return <Label text={taskStatus.deadlinePassed} type={LabelTypes.ERROR_SMALL} icon={IconTypes.UTROPSTEGN_24} />;
    }

    if (status === SigningOrderStatusEnum.CANCELLED) {
        return <Label text={taskStatus.cancelled} type={LabelTypes.ERROR_SMALL} icon={IconTypes.UTROPSTEGN_24} />;
    }

    if (status === SigningOrderStatusEnum.FINISHED_SIGNING && signee && signingDate) {
        return (
            <Label
                text={formatTranslation(taskStatus.signed, signingDate, signee.name)}
                type={LabelTypes.SUCCESS_SMALL}
                icon={IconTypes.USP_CHECKMARK_24}
            />
        );
    }
    if (status === SigningOrderStatusEnum.REJECTED) {
        return <Label text={taskStatus.rejected} type={LabelTypes.ERROR_SMALL} icon={IconTypes.UTROPSTEGN_24} />;
    }

    if (status === SigningOrderStatusEnum.READY_FOR_CANCELLATION) {
        return (
            <Label
                text={taskStatus.readyForCancellation}
                type={LabelTypes.ERROR_SMALL}
                icon={IconTypes.UTROPSTEGN_24}
            />
        );
    }

    return (
        <>
            {deadline && (status === SigningOrderStatusEnum.READY_FOR_SIGNING || !signee?.harSignert) && (
                <>
                    <Label
                        text={
                            deadlineIsToday
                                ? taskStatus.deadlineToday
                                : formatTranslation(taskStatus.deadline, deadline)
                        }
                        type={deadlineIsToday ? LabelTypes.INVERTED_SMALL : LabelTypes.WARNING_SMALL}
                    />
                    <Label text={taskStatus.requiresAction} type={LabelTypes.ATTENTION_SMALL} />
                </>
            )}
            {status === SigningOrderStatusEnum.PARTIALLY_SIGNED && signee?.harSignert && (
                <>
                    {signee && signingDate && (
                        <Label
                            text={formatTranslation(taskStatus.signed, signingDate, signee.name)}
                            type={LabelTypes.SUCCESS_SMALL}
                            icon={IconTypes.USP_CHECKMARK_24}
                        />
                    )}
                    <Label text={taskStatus.waitingForOtherSignees} type={LabelTypes.ATTENTION_SMALL} />
                </>
            )}
        </>
    );
};
export default ({ status, deadline, signee, deadlineIsToday }: SigningOrderLabelsInterface) => (
    <div className="signing-order-labels">
        <SigningOrderLabels signee={signee} status={status} deadline={deadline} deadlineIsToday={deadlineIsToday} />
    </div>
);
